import React from "react";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../assets/logo1.png";
import "./CSS/Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <footer
      ref={ref}
      className="bg-gray-400 text-black p-4"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
        fontSize: "15px",
      }}
    >
      <div className="container mx-auto flex flex-wrap justify-center items-center space-x-4">
        <div className="flex flex-col items-center justify-center text-center p-4">
          <img src={logo} alt="Montriver Logo" style={{ height: "60px" }} />
          <p style={{ fontSize: "16px" }}>© 2025 iBuilders</p>
        </div>
        <div className="flex flex-col items-center justify-center text-center p-4">
          {/* <h4 style={{ textDecoration: "underline", paddingBottom: "1rem" }}>
            Follow Us
          </h4> */}
          <div className="social-icons flex">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                size="2x"
                style={{ paddingRight: "1rem" }}
              />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebookF}
                size="2x"
                style={{ paddingRight: "1rem" }}
              />
            </a>
            <a
              href="https://tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faTiktok}
                size="2x"
                style={{ paddingRight: "1rem", paddingBottom: "2rem" }}
              />
            </a>
          </div>
          <div>
            <Link
              to="/partnerships" // The internal route
              style={{
                fontSize: "18px",
                textDecoration: "underline",
              }}
            >
              Partnerships
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
